import * as _ from 'lodash';
import { ClonableItem } from 'src/app/shared';
import ISystemEventDTO = ZoningAPI.ISystemEventDTO;
import { ISystemEvent } from '../interfaces/system-event.interface';
import { getPrettyParentType, SystemEventParentType } from '../enums/system-event-parent-type';
import { SystemEventType, getPrettyEventType } from '../enums/system-event-type-enum';
import * as moment from 'moment';
import { DATETIME_FORMAT } from '../utils/utils';

export class SystemEvent extends ClonableItem<ISystemEvent<any>> implements ISystemEvent<any> {
    Id: number;
    ParentId: string;
    ParentType: SystemEventParentType;
    UserId?: number;
    EventType: SystemEventType;
    MetaData?: any;
    createdAt?: Date;
    createdAtStr: string;
    eventTypeStr: string;
    parentTypeStr: string;

    constructor(data: ISystemEventDTO<any>) {
        super(data);
        this.createdAtStr = moment(this.createdAt).format(DATETIME_FORMAT);
        this.eventTypeStr = getPrettyEventType(this.EventType);
        this.parentTypeStr = getPrettyParentType(this.ParentType);
    }

    get isProcessClearStuckThread(): boolean {
        return this.EventType === SystemEventType.PROCESS_CLEAR_STUCK_THREAD;
    }

    get showJSONMetaData(): boolean {
        return (
            [
                SystemEventType.BULK_CREATE_FAILED,
                SystemEventType.BULK_UPDATE_FAILED,
                SystemEventType.PRS_INCORRECT_SORL_AU
            ].indexOf(this.EventType) >= 0
        );
    }

    getJSON() {
        return _.pick(this, ['Id', 'ParentId', 'ParentType', 'UserId', 'EventType', 'MetaData']);
    }
}

export function SystemEventFactory(data: ISystemEventDTO<any>) {
    return new SystemEvent(data);
}
